import {
    useMemo,
} from 'react'

import {
    userSelectionConfig,
} from 'app/requests/User.requests'
import ChipSelect from 'app/shared-components/ChipSelect'
import useDelayedLoadOptions from 'app/hooks/useDelayedLoadOptions'
import useGetUsers from 'app/Apps/ContactManagement/Users/hooks/useGetUsers'
import {
    NotificationIconProps,
} from 'app/shared-components/NotificationIcon/notificationIcon.types'

type Props = {
    value?: {
        id: number,
    }[],
    onChange: (newValue: number[]) => void,
    title?: string,
    disabled?: boolean,
    required?: boolean,
    notificationIconProps?: NotificationIconProps,
    includeFilters?: Record<string, any>,
    className?: string,
}

const defaultProps: Partial<Props> = {
    value: [],
    title: 'Users',
    disabled: false,
    required: false,
    notificationIconProps: undefined,
    includeFilters: undefined,
    className: '',
}

const MultipleUserSelector = ({
    value,
    onChange,
    title,
    disabled,
    required,
    notificationIconProps,
    includeFilters,
    className,
}: Props) => {
    const loadOptions = useDelayedLoadOptions({
        ...userSelectionConfig, includeFilters,
    })

    const userIds = useMemo(() => {
        return value.map(({
            id,
        }) => {
            return id
        })
    }, [value])

    const {
        data: users,
    } = useGetUsers(userIds)

    const enhancedValue = useMemo(() => {
        if (!userIds?.length) {
            return []
        }

        return users?.map(({
            id, userName,
        }) => {
            return {
                label: userName,
                value: id,
                id,
            }
        })
    }, [
        userIds?.length,
        users,
    ])

    return (
        <div className={className}>
            <ChipSelect
                title={title}
                value={enhancedValue}
                onChange={onChange}
                loadOptions={loadOptions}
                showTitleOptions
                disabled={disabled}
                required={required}
                notificationIconProps={notificationIconProps}
                menuShouldBlockScroll
                menuPortalTarget={document.body}
            />
        </div>
    )
}

MultipleUserSelector.defaultProps = defaultProps

export default MultipleUserSelector
